import {Capacitor} from '@capacitor/core'
import {Badge} from '@capawesome/capacitor-badge'

export class BadgeService {

  async increase(): Promise<void> {
    if (Capacitor.getPlatform() === 'web') {
      return
    }
    try {
      const isSupported = await Badge.isSupported()
      if (!isSupported.isSupported) {
        return
      }
      const {count} = await Badge.get()
      await Badge.set({count: (count ?? 0) + 1})
    } catch (error) {
      console.warn('Failed to increase badge count.', error)
    }
  }

  async clear(): Promise<void> {
    if (Capacitor.getPlatform() === 'web') {
      return
    }
    try {
      const isSupported = await Badge.isSupported()
      if (!isSupported.isSupported) {
        return
      }
      await Badge.clear()
    } catch (error) {
      console.warn('Failed to clear badge count.', error)
    }
  }
}
